import type {
	LWApiPublicBillingStripePaymentMakeParamsRaw,
	LWApiPublicBillingStripePaymentMakeResultRaw,
} from '@liquidweb-dev/club-sauce/public/billing/stripe/payment/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'modules/queries/api';
import { BILLING_BALANCE_QUERY_KEY } from 'modules/queries/billing/useBalance';
import { BILLING_PAYMENT_INSTRUMENT_LIST_QUERY_KEY } from 'modules/queries/billing/payment/instrument/useList';

const useBillingStripePaymentMake = () => {
	const queryClient = useQueryClient();

	return useMutation<
		LWApiPublicBillingStripePaymentMakeResultRaw,
		ApiErrorI,
		LWApiPublicBillingStripePaymentMakeParamsRaw
	>({
		mutationFn: (params) => api.billing.stripe.payment.apiRaw.make(params),

		// `onSettled`, not `onSuccess`: this call is the capture, and an error
		// response does not mean no payment was taken - a request that never came
		// back may well have landed. Refetching either way costs a request and
		// keeps a settled balance from being paid a second time.
		onSettled: () => {
			queryClient.invalidateQueries({
				queryKey: [BILLING_BALANCE_QUERY_KEY],
			});
			// possible to add an instrument with this method so invalidate list of instruments
			queryClient.invalidateQueries({
				queryKey: [BILLING_PAYMENT_INSTRUMENT_LIST_QUERY_KEY],
			});
		},
	});
};

export default useBillingStripePaymentMake;
